import {gql} from '@apollo/client';

export const FRAGMENT_LESSON_LIST = gql`
  fragment LessonList on LessonType {
    id
    name
    level
    vocabularyPass
    trialPass
    finalPass
    intermediatePass
    finalVariants
    importance
  }
`;

export const QUERY_LESSON_LIST = gql`
  query LessonList {
    lessonList {
      ...LessonList
    }
  }
  ${FRAGMENT_LESSON_LIST}
`;

export const QUERY_LESSON_DETAIL = gql`
  query LessonDetail($id: ID!) {
    lessonDetail(id: $id) {
      ...LessonList
      vocabularyContent
      grammarContent
      phoneticsContent
      finalAttempts
      intermediateAttempts
      trialAttempts
      vocabularyAttempts
    }
  }
  ${FRAGMENT_LESSON_LIST}
`;

export const MUTATION_STUDY_PASS_PHONETICS = gql`
  mutation StudyPassPhonetics($input: StudyPassPhoneticsInput!) {
    studyPassPhonetics(input: $input) {
      obj {
        id
        phoneticsPassed
        vocabularyPassed
        trialPassed
        finalPassed
        client {
          id
          currentLevel
          currentStart
          isRepeat
        }
      }
      errors {
        field
        messages
      }
    }
  }
`;
